import { Trans, useT } from '@eturi/react-i18next'
import { memo } from 'react'
import { Link } from 'react-router-dom'
import { setPairModalType } from '../../reducers/pair.slice'
import { useAppDispatch } from '../../types'
import { Btn, HybridModal } from '../../widgets'
import PairingComparisonTable from './PairingComparisonTable'

type PairDeviceModalProps = {
	readonly onClose: () => void
}

const PairDeviceModal = ({ onClose }: PairDeviceModalProps) => {
	const d = useAppDispatch()
	const [t] = useT('connect.pair_modals')

	return (
		<HybridModal header={t.$('actions.pair_device')} onClose={onClose}>
			<div className="flex flex-col gap-2 items-center max-w-[500px]">
				<p>
					<Trans i18nKey="pairing_options_description" t={t} />
				</p>
				<PairingComparisonTable />
				<div className="max-w-96 w-full flex flex-col my-3 mx-auto">
					<Btn
						className="w-full uppercase"
						onClick={() => {
							d(setPairModalType('quick_pair'))
						}}
					>
						{t.$('actions.quick_pair')} ({t('pairing_options_apple_only')})
					</Btn>
					<Link
						className="btn btn-teal-invert border-solid border-teal border-2 mt-3.5 min-w-32 uppercase"
						to={{ pathname: '/connect', search: 'hideSkip=true' }}
						onClick={onClose}
					>
						{t.$('actions.full_pair')}
					</Link>
				</div>
				<p>*{t('pairing_options_disclaimer')}</p>
			</div>
		</HybridModal>
	)
}

export default /*@__PURE__*/ memo(PairDeviceModal)
